import { ErrorIcon } from 'tuui';
import { useRejectedAudiencesIndication } from '../../../../modules/audiences/hooks/useRejectedAudiencesIndication';
import styles from './AudiencesBadge.module.scss';

export const AudiencesBadge = () => {
    const { hasRejectedAudiences } = useRejectedAudiencesIndication();

    return hasRejectedAudiences ? (
        <ErrorIcon style={{ fontSize: 'medium' }} className={styles['warning-icon']} />
    ) : null;
};
